<section class="login-page">
  <!-- LAYER 1: Full Screen Background Image -->
  <img src="assets/img/login_page_design.jpg" alt="Background" class="background-image">

  <!-- LAYER 2: Lock Container (ON TOP of background, right side) -->
  <div class="lock-container">

    <!-- Lock Status Indicator (ON TOP of card) -->
    <img src="assets/img/lock_normal.png" alt="Lock Normal" class="lock-status lock-normal"
      *ngIf="authentic == null">
    <img src="assets/img/lock_red.png" alt="Lock Invalid" class="lock-status lock-red"
      *ngIf="(loginForm.touched && !loginForm.valid) || authentic == false">
    <img src="assets/img/lock_green.png" alt="Lock Valid" class="lock-status lock-green" *ngIf="authentic == true">

    <!-- LAYER 3: Login Card (ON TOP of lock image) -->
    <div class="login-card mb-3">
      <div class="logo-section">
        <img src="assets/img/logodark.png" alt="Logo" class="logo-icon">
        <!-- <span class="logo-text">Lynkgrid.</span> -->
      </div>

      <p class="subtitle">Container Terminal Management System</p>

      <form [formGroup]="loginForm" class="login-form">
        <div class="input-wrapper">
          <span class="input-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="2" y="4" width="20" height="16" rx="2" />
              <path d="M22 6L12 13L2 6" />
            </svg>
          </span>
          <input type="email" formControlName="email" placeholder="Email / Mobile Number" class="form-input">
        </div>

        <div class="input-wrapper">
          <span class="input-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="11" width="18" height="11" rx="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </span>
          <input [type]="isPasswordVisible ? 'text' : 'password'" formControlName="password" placeholder="Password"
            class="form-input">
        </div>

        <div class="options-row">
          <label class="checkbox-wrapper">
            <input type="checkbox" (change)="togglePasswordVisibility()">
            <span class="checkbox-label">Show password</span>
          </label>
          <a href="javascript:void(0)" class="forgot-link" data-bs-toggle="modal" data-bs-target="#forgetModal">Forgot
            Password?</a>
        </div>

        <button type="submit" class="signin-button" [disabled]="!loginForm.valid" (click)="login()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
            <polyline points="10 17 15 12 10 7" />
            <line x1="15" y1="12" x2="3" y2="12" />
          </svg>
          <span>Sign In</span>
        </button>
      </form>

      <div class="tracking-row">
        <a href="javascript:void(0)" class="tracking-link" data-bs-toggle="modal" data-bs-target="#trackingModal"
          (click)="trackEvent('container_tracking')">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12">
            <rect x="1" y="3" width="15" height="13" rx="2" />
            <path d="M16 8h4l3 3v5h-7V8z" />
            <circle cx="5.5" cy="18.5" r="2.5" />
            <circle cx="18.5" cy="18.5" r="2.5" />
          </svg>
          Container Tracking
        </a>
      </div>

      <p class="footer-text">Don't have an account?
        <a href="https://support.lynkit.in/portal/en/newticket?departmentId=43764000193023086&layoutId=43764000193029519"
          class="contact-link">Contact Us</a>
      </p>
    </div>
  </div>

  <!-- Forgot Password Modal -->
  <div class="modal fade" id="forgetModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-dark">
        <div class="modal-header border-0">
          <h5 class="modal-title">Forgot Your Password?</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
            (click)="closeForgetModal()"></button>
        </div>
        <div class="modal-body">
          <p class="modal-subtitle" *ngIf="!isGetOtp">Enter your registered email/mobile to reset your password</p>
          <p class="modal-subtitle" *ngIf="isGetOtp">Enter the OTP sent to your email/mobile</p>

          <form [formGroup]="getEmailForm" *ngIf="!isGetOtp">
            <div class="input-wrapper modal-input">
              <input type="email" formControlName="email" placeholder="Email / Mobile Number" class="form-input">
            </div>
            <button type="button" class="signin-button" [disabled]="!getEmailForm.get('email')?.valid"
              (click)="getOTP()">Get OTP</button>
          </form>

          <form [formGroup]="forgetPwForm" *ngIf="isGetOtp">
            <div class="input-wrapper modal-input">
              <input type="text" formControlName="otp" placeholder="Enter OTP" class="form-input"
                (keypress)="restrictNumeric($event)">
            </div>
            <div class="input-wrapper modal-input">
              <input type="password" formControlName="newPassword" placeholder="New Password" class="form-input">
            </div>
            <small class="password-hint">Min 8 chars: 1 uppercase, 1 lowercase, 1 number, 1 special char</small>
            <button type="button" class="signin-button" [disabled]="!forgetPwForm.valid"
              (click)="forgetPassword()">Reset Password</button>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Container Tracking Modal -->
  <div class="modal fade" id="trackingModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-dark">
        <div class="modal-header border-0">
          <h5 class="modal-title">Track Container</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
            (click)="resetContainer()"></button>
        </div>
        <div class="modal-body">

          <form [hidden]="containersData?.length != 0" [formGroup]="trackingForm">
            <div formArrayName="baseForm" *ngFor="let item of baseForm.controls; let i = index;">
              <div [formGroupName]="i" class="tracking-input-row">
                <div class="input-wrapper modal-input">
                  <input formControlName="container" maxlength="11" placeholder="Container No (e.g. ABCD1234567)"
                    class="form-input">
                </div>
                <div class="tracking-input-actions">
                  <button type="button" class="tracking-action-btn add" (click)="addItem()"
                    *ngIf="i === baseForm.length - 1">+</button>
                  <button type="button" class="tracking-action-btn remove" (click)="deleteRow(i)"
                    *ngIf="baseForm.length > 1">-</button>
                </div>
              </div>
            </div>
            <div class="input-wrapper modal-input">
              <input formControlName="cfs" placeholder="ICD / CFS" class="form-input">
            </div>
          </form>

          <div *ngIf="containersData?.length != 0" class="tracking-results">
            <table class="tracking-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Container</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of containersData; let i = index;">
                  <td>{{i + 1}}</td>
                  <td>{{item.containerDetails.container}}</td>
                  <td>
                    <span *ngIf="!item.tid">Gate In Pending</span>
                    <span *ngIf="item.tid && item.lastStatus == 'gatein'">Gate In</span>
                    <span
                      *ngIf="item.tid && !item.tidRetrieved && item.lastStatus != 'gatein' && item.moves?.length > 0 && item.moves[0]?.positionDetails?.time?.length > 0">
                      Gate In - {{item.loc}}
                      <button *ngIf="item?.containerDetails?.actionType != 'anotherYard'"
                        class="tracking-map-btn" (click)="goToMap(item._id)">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14"
                          height="14">
                          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                          <circle cx="12" cy="10" r="3" />
                        </svg>
                      </button>
                    </span>
                    <span *ngIf="item.tid && item.tidRetrieved && item.lastStatus == 'loading'">Gate Out</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
        <div class="modal-footer border-0">
          <button type="button" class="signin-button modal-btn" data-bs-dismiss="modal"
            (click)="resetContainer()">Close</button>
          <button *ngIf="containersData?.length == 0" type="button" class="signin-button modal-btn accent"
            [disabled]="!trackingForm?.valid" (click)="trackContainer()">Track</button>
          <button *ngIf="containersData?.length != 0 && viewAllMap" type="button"
            class="signin-button modal-btn" (click)="multiMap()">View on Map</button>
          <button *ngIf="containersData?.length != 0" type="button" class="signin-button modal-btn accent"
            (click)="resetContainer()">Track Another</button>
        </div>
      </div>
    </div>
  </div>
</section>